var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPined = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z",
  "data-name": "Rectangle 25320"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M4.72 15.51h14.143",
  "data-name": "Line 1899"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M7.55 5.611h8.484",
  "data-name": "Line 1900"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m7.048 15.51 2.825-9.899",
  "data-name": "Line 1901"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  d: "m16.537 15.513-2.828-9.9",
  "data-name": "Path 5261"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m11.792 15.51.106 5.465",
  "data-name": "Line 1903"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.196 5.61 7.179 15.684h9.223L13.49 5.61Z",
  "data-name": "Path 5262"
})));
export { SvgPined as ReactComponent };
export default "/_next/static/images/Pined.svg";